import React, { useState, useEffect } from "react";
import { useStores } from "@/store";

/**预登录 */
const Auth = (props) => {
  const { memberStore } = useStores();
  const [hasLogin, setLogin] = useState(true);
  const [isSafe, setSafe] = useState(false);
  const getUser = async () => {
    const token = await window.getLoginToken();
    window.private_token = token;
    if (window.location.hash.indexOf("/h5/") >= 0 && !token) {
      setSafe(true);
    } else {
      memberStore
        .show()
        .then(() => {
          setLogin(true);
          setSafe(false);
        })
        .catch((error) => {
          setLogin(true);
          setSafe(false);
        });
    }
  };

  useEffect(() => {
    getUser();
  }, []);
  return isSafe || hasLogin ? (
    <React.Fragment>{props.children}</React.Fragment>
  ) : (
    <div></div>
  );
};

export default Auth;
